import { Component, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AcessoService } from '../../service/acesso/acesso.service';
import { LocalStorage } from 'src/app/service/classes/localstorage/LocalStorage';
import { Crypto } from 'src/app/service/classes/crypto/crypto';

@Injectable({
  providedIn: 'root',
})
export class ProgramacaoFeriasService {
  localStorage: LocalStorage = new LocalStorage();
  headers = new HttpHeaders();
  filial: string = '';
  cabecalho: any = null;
  data: any = new Date();
  mes: number = this.data.getMonth() + 1;
  ano: number = this.data.getFullYear();
  url_acesso: any = this.acesso.validarUrl();
  competencia: string = this.ano.toString() + this.mes.toString();

  constructor(private http: HttpClient, private acesso: AcessoService) {
    if (localStorage.getItem('util') != null) {
      this.localStorage = JSON.parse(new Crypto().decryptUsingAES256(localStorage.getItem('util')));
      this.cabecalho = this.headers.append('sessao', this.localStorage.Sessao);
      this.filial = this.localStorage.FilialAtual.toString();
    }
  }

  buscarColaborador(matricula: number) {
    return this.http.get(
      `${this.url_acesso}elogios-penalidades/usuario/${this.competencia}/${matricula}/${this.filial}`,
      { headers: this.cabecalho }
    );
  }
  buscarTipoCompetencia(TipoProcessamento: any) {
    return this.http.get(
      `${this.url_acesso}competenciaAberta/${TipoProcessamento}/${this.filial}`,
      { headers: this.cabecalho }
    );
  }

  buscarClassificacao() {
    return this.http.get(
      `${this.acesso.validarUrl()}falta-ao-trabalho/listar-id-classificacao-ato`,
      {
        headers: this.cabecalho,
      }
    );
  }

  buscarParametrosIniciais() {
    return this.http.get(`${this.url_acesso}ferias-rh/parametros-iniciais`, {
      headers: this.cabecalho,
    });
  }

  buscarTipoFerias() {
    return this.http.get(`${this.url_acesso}ferias-rh/tipos-ferias`, { headers: this.cabecalho });
  }

  buscarSituacao() {
    return this.http.get(`${this.url_acesso}ferias-rh/situacoes`, { headers: this.cabecalho });
  }

  buscarDiasFaltas(matricula: number) {
    return this.http.get(`${this.url_acesso}ferias-rh/dias-faltas/${this.filial}/${matricula}`, {
      headers: this.cabecalho,
    });
  }

  buscarDiasDescontados(tipoEmpresa: string, diasFaltas: string) {
    return this.http.get(
      `${this.url_acesso}ferias-rh/dias-descontados/${tipoEmpresa}/${diasFaltas}`,
      { headers: this.cabecalho }
    );
  }

  salvarProgramacaoFerias(programacaoFerias: any) {
    return this.http.post(`${this.url_acesso}ferias-rh/programacao-ferias`, programacaoFerias, {
      headers: this.cabecalho,
    });
  }

  deletarProgramacaoFerias(
    empFil: string,
    matricula: number,
    tpProc: string,
    priAqFerias: string,
    segAqFerias: string
  ) {
    return this.http.delete(
      `${this.url_acesso}ferias-rh/programacao-ferias/${empFil}/${matricula}/${tpProc}/${priAqFerias}/${segAqFerias}`,
      { headers: this.cabecalho }
    );
  }

  atualizarProgramacaoFerias(
    empFil: any,
    matricula: number,
    tpProc: string,
    priAqFerias: string,
    segAqFerias: string,
    dadosAtualizados: any
  ) {
    return this.http.put(
      `${this.url_acesso}ferias-rh/programacao-ferias/${empFil}/${matricula}/${tpProc}/${priAqFerias}/${segAqFerias}`,
      dadosAtualizados,
      { headers: this.cabecalho }
    );
  }

  listarProgramacaoFerias(empFil: string, matricula?: number, situacao?: string) {
    let params = new HttpParams();

    if (matricula) {
      params = params.set('mat', matricula);
    }

    if (situacao) {
      params = params.set('sit', situacao);
    }

    return this.http.get(`${this.url_acesso}ferias-rh/programacao-ferias/${empFil}`, {
      headers: this.cabecalho,
      params,
    });
  }

  buscarDataRetorno(empFil: string, matricula: number, data: string) {
    return this.http.get(
      `${this.url_acesso}ferias-rh/proximo-dia-util/${empFil}/${matricula}/${data}`,
      {
        headers: this.cabecalho,
      }
    );
  }

  verificarDataInicio(empFil: string, matricula: number, tipoEmpresa: string, data: string) {
    return this.http.get(
      `${this.url_acesso}ferias-rh/verificar-dia-util/${empFil}/${matricula}/${tipoEmpresa}/${data}`,
      {
        headers: this.cabecalho,
      }
    );
  }

  calcularDiaRetorno(empFil: string, matricula: number, data: string) {
    return this.http.get(
      `${this.url_acesso}ferias-rh/proximo-dia-util/${empFil}/${matricula}/${data}`,
      {
        headers: this.cabecalho,
      }
    );
  }

  buscarPeriodoAquisitivo(empFil: string, matricula: number, tipoEmpresa: string) {
    return this.http.get(
      `${this.url_acesso}ferias-rh/proximo-periodo-aquisitivo/${empFil}/${matricula}/${tipoEmpresa}`,
      {
        headers: this.cabecalho,
      }
    );
  }

  editarProgramacaoFerias(
    empFil: string,
    matricula: number,
    tpProc: string,
    priAqFerias: string,
    segAqFerias: string
  ) {
    return this.http.get(
      `${this.url_acesso}ferias-rh/programacao-ferias/${empFil}/${matricula}/${tpProc}/${priAqFerias}/${segAqFerias}`,
      {
        headers: this.cabecalho,
      }
    );
  }

  buscarCompetenciaAberta(tpProc: string, empFil: string) {
    return this.http.get(`${this.url_acesso}competenciaAberta/${tpProc}/${empFil}`, {
      headers: this.cabecalho,
    });
  }

  buscarDadosFaltas(matricula: number, empFil: string, tipoEmpresa: string) {
    return this.http.get(
      `${this.url_acesso}ferias-rh/dias-faltas-descontados/${empFil}/${matricula}/${tipoEmpresa}`,
      { headers: this.cabecalho }
    );
  }


  buscarHistoricoGozos(priAqFerias: string,segAqFerias: string, numOrd: string) {
    let params = new HttpParams();
  
    if (priAqFerias) {
      params = params.set('iniAq', priAqFerias);
    }
    
    if (segAqFerias) {
      params = params.set('fimAq', segAqFerias);
    }

    // if (data) {
    //   params = params.set('dtIni', data);
    // }

    if (numOrd) {
      params = params.set('numOrd', numOrd);
    }
  
  
  
    return this.http.get(`${this.url_acesso}ferias-rh/ferias-gozo`, {
      headers: this.cabecalho,
      params,
    });
  }
  

salvarSaldoFerias(saldoFerias: any) {
    return this.http.post(`${this.url_acesso}ferias-rh/ferias-gozo`, saldoFerias, {
      headers: this.cabecalho,
    });
  }


  removerGozoFerias( numeroOrdem: string, priAqFerias: string, segAqFerias: string, dataInicioGozo: string) {
    return this.http.delete(`${this.url_acesso}ferias-rh/ferias-gozo/${numeroOrdem}/${priAqFerias}/${segAqFerias}/${dataInicioGozo}`, {
      headers: this.cabecalho,
    });
  }

 
  
  downloadPDF(empFil: string, mat: number) {
    return this.http.get(
      `${this.url_acesso}relatorios-pdf/download-pdf/${empFil}/${mat}/6`,
      {
        headers: this.cabecalho,
      }
    );
  }

}
